import { useMemo } from 'react'
import { FilterI } from '../constants/filter'
import { add_kdp_filters } from '../util/kdp_cols'
import { useUser } from './useUser'

// Adds the KDP filters, if the loaded profile is a KDP profile
export const useKdpFilters = (defaultFilters: FilterI[]) => {
    const { activeProfile } = useUser()

    const hasAcosField = defaultFilters.some((filter) => filter.key === 'acos')

    return useMemo(() => {
        if (activeProfile?.is_kdp && hasAcosField) {
            return add_kdp_filters([...defaultFilters])
        } else {
            return [...defaultFilters]
        }
    }, [activeProfile?.is_kdp, hasAcosField])
}
